import React, { FC } from "react";
import type { GetStaticPaths, GetStaticProps } from "next";
import PageTemplate from "src/components/templates/PageTemplate";
import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import LegalDocument from "@/components/legals/LegalDocument";
import {
  getLegalDoc,
  getLegalDocSlugs,
  type LegalDocResolved,
} from "@/libs/legals";

type Props = { doc: LegalDocResolved };

const Legals: FC<Props> = ({ doc }) => (
  <PageTemplate>
    {/* 정적 프리렌더 — 띠의 시각 판정을 요청 시각에 못 한다 (#5655 R3 x1). */}
    <PageTemplate.Content hidePromoBanner>
      <LegalDocument doc={doc} />
    </PageTemplate.Content>
  </PageTemplate>
);

// 법률 문서는 빌드 시점에 고정된 정적 콘텐츠다. SSG 로 내보내야 SNS/검색 크롤러가
// 본문을 읽는다 — 이전 구현은 클라이언트에서 sdk-api 를 불러 HTML 이 비어 있었다
// (docs/pitfalls.md #3).
export const getStaticPaths: GetStaticPaths = ({ locales = [] }) => ({
  paths: getLegalDocSlugs().flatMap((id) =>
    locales.map((locale) => ({ params: { id }, locale })),
  ),
  fallback: false,
});

export const getStaticProps: GetStaticProps<Props> = async ({
  params,
  locale,
}) => {
  const doc = getLegalDoc(String(params?.id), locale);
  if (!doc) return { notFound: true };
  return {
    props: {
      doc,
      ...(await serverSideTranslations(locale ?? "en", [
        "support",
        "index",
        "gnb",
      ])),
    },
  };
};

export default Legals;
